import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { baseInquiryEffects, baseInquiryReducer } from '../../_store';

@NgModule({
  imports: [
    StoreModule.forFeature('inquiries', baseInquiryReducer.BaseInquiryReducer),
    EffectsModule.forFeature([baseInquiryEffects.BaseInquiryEffects]),
  ],
})
export class BaseInquiryStoreModule {}
